import {IVehicleOnBoardActionTypes,IVehicleOnBoardActionCreator} from 'models/IVehicleonBoardState';

const initialState:any = {
    is_api_in_request: false,
    status:null,
    message: ''
}

const reducer = (state = initialState, { type, payload }: IVehicleOnBoardActionCreator) => {
    switch (type) {
        case IVehicleOnBoardActionTypes.ADD_VEHICLE_REQUEST:
            return {
                ...initialState,
                is_api_in_progress: true
            }
        case IVehicleOnBoardActionTypes.ADD_VEHICLE_SUCCESS:
            return {
                ...state,
                status:200,
                message: 'Added Route successfully'
            }
        case IVehicleOnBoardActionTypes.ADD_VEHICLE_FAILURE:
            return {
                ...state,
                is_api_in_progress:false,
                ...payload
            } 
        case IVehicleOnBoardActionTypes.RESET_ADD_VEHICLE_STATE:
            return {
                ...initialState
            }  
        default:
            return state;
    }
};
  
  export default reducer;